export class ConfigurationConstants {
  public static readonly CONFIG_FILE_LOCATION = 'assets/config/configuration.json';
  public static readonly ENTITIES_LOCATIONS = 'assets/locations/capitals-locations.json';
  public static readonly COMPLIANCE_CENTRAL_WORKSPACE_CHOICE = 'complianceCentral';
  public static readonly CREATE_DOCUMENTATION_WORKSPACE_CHOICE = 'createDocumentation';
  public static readonly START_UP_MENU = 'startUpMenu';
  public static readonly CONFIRMATION_TEXT = 'Fiona';
  public static readonly PRODUCT_NAME = 'tpiq';
}
